var React = require('react');
const PropTypes = React.PropTypes; //TODO: react 15.5 -> require( 'prop-types' );
var {cancelAnimationFrame, requestAnimationFrame} = require('../../polyfills/requestAnimationFrame');

class AccordionTab extends React.Component {
    constructor(props, context) {
        super(props)

        if (!props.children || props.children.length != 2) {
            throw new Error('Accordion tab must have exactly 2 children!');
        }

        this.animation = {
            height: {
                start: null,
                end: null
            },
            paddingTop: {
                start: null,
                end: null
            },
            paddingBottom: {
                start: null,
                end: null
            },
            startTime: null,
            initialFrame: false,
        }

        this.state = this.getDefaultComponentState(props)
        this.group = this.props.group || Math.random()

        this.currentAnimation = null;

        this.handleHeadlineClick = this.handleHeadlineClick.bind(this);
        this.animateExpand = this.animateExpand.bind(this);
        this.animateCollapse = this.animateCollapse.bind(this);
        this.handleOtherTabOpen = this.handleOtherTabOpen.bind(this);

        context.emitter.on('tabOpen', this.handleOtherTabOpen);
    }

    componentWillUnmount(){
        cancelAnimationFrame(this.currentAnimation)
        this.context.emitter.removeListener('tabOpen', this.handleOtherTabOpen);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.open != nextProps.open && nextProps.open !== undefined) {
            if (nextProps.open) {
                this.expand()
            } else {
                this.collapse()
            }
        }
    }

    getDefaultComponentState(props) {
        return {
            open: props.open,
            animationInProgress: false,
            animation: {
                height: null,
                paddingTop: null,
                paddingBottom: null
            }
        };
    }

    render() {
        var classNames = this.props.className?this.props.className:'' + ' lr-components-accordion-tab'
        return <div className={classNames}>
            {this.showChildren()}
        </div>
    }

    handleOtherTabOpen(group, name) {
        if (group == this.group && name != this.props.name && this.state.open) {
            this.collapse();
        }
    }

    collapse() {
        this.context.emitter.emit('tabClose', this.group, this.props.name)
        cancelAnimationFrame(this.currentAnimation)
        this.setState({
            animationInProgress: true,
            open: false,
        })
        this.animation.initialFrame = true
        this.currentAnimation = requestAnimationFrame(this.animateCollapse);
    }

    expand() {
        this.context.emitter.emit('tabOpen', this.group, this.props.name)
        cancelAnimationFrame(this.currentAnimation)
        this.setState({
            animationInProgress: true,
            open: true,
        })

        this.animation.initialFrame = true
        this.currentAnimation = requestAnimationFrame(this.animateExpand);
    }

    handleHeadlineClick(e) {
        if (!this.state.open) {
            this.expand();
        } else {
            this.collapse();
        }
    }

    showChildren() {
        var Headline = this.props.children[0].type;
        var Body = this.props.children[1].type;
        var animationStyle = !this.state.animationInProgress?{
            display: this.state.open ? 'block' : 'none',
        }:{
            height: this.state.animation.height,
            overflow: 'hidden',
            display: 'block',
            paddingTop: this.state.animation.paddingTop,
            paddingBottom: this.state.animation.paddingBottom
        };

        return [
            <Headline {...this.props.children[0].props} className={(this.state.open?'open ':'') + (this.props.children[0].props.className ||'')} key='headline'
                                                        onClick={this.handleHeadlineClick}>{this.props.children[0].props.children}</Headline>,
            <Body {...this.props.children[1].props} style={animationStyle} key='body'
                                                    ref={(ref) => this.body = ref}>{this.props.children[1].props.children}</Body>
        ];
    }

    animateExpand(time) {
        var finalStyles = this.getFinalExpandStyles();
        var {finalHeight, finalPaddingTop, finalPaddingBottom} = finalStyles;
        var startTime = this.getStartTime(time);
        var progress = this.getProgress(time);
        var {newHeight, newPaddingBottom, newPaddingTop} = this.getProgressExpandStyles(progress, finalStyles);

        if (progress < 1) {
            this.setState({
                open: true,
                animationInProgress: true,
                animation: {
                    height: newHeight,
                    paddingTop: newPaddingTop,
                    paddingBottom: newPaddingBottom
                }
            })

            this.animation = {
                height: {
                    start: 0,
                    end: finalHeight
                },
                paddingTop: {
                    start: 0,
                    end: finalPaddingTop
                },
                paddingBottom: {
                    start: 0,
                    end: finalPaddingBottom
                },
                startTime: startTime,
                initialFrame: false,
            }

            this.currentAnimation = requestAnimationFrame(this.animateExpand)
        } else {
            this.setState(this.getDefaultComponentState({open:true}))
            this.context.emitter.emit('tabOpenAnimationEnd', this.group, this.props.name)
        }
    }

    getProgressExpandStyles(progress, finalStyles) {
        var {finalHeight, finalPaddingTop, finalPaddingBottom} = finalStyles;
        var newHeight = this.getValueByProgress(progress, 0, finalHeight);
        var newPaddingBottom = this.getValueByProgress(progress, 0, finalPaddingBottom);
        var newPaddingTop = this.getValueByProgress(progress, 0, finalPaddingTop);
        return {newHeight: newHeight, newPaddingBottom: newPaddingBottom, newPaddingTop: newPaddingTop};
    }

    getFinalExpandStyles() {
        var finalHeight = this.animation.height.end
        var finalPaddingTop = this.animation.paddingTop.end
        var finalPaddingBottom = this.animation.paddingBottom.end
        var initialFrame = this.animation.initialFrame
        if (initialFrame) {
            // we need to set this here to measure the end height. not shown in browser, jquery does it the same
            this.body.style.display = 'block';
            finalHeight = this.body.getBoundingClientRect().height;
            // sure we could use jquery but it's not cool anymore, right?
            finalPaddingTop = parseFloat(getComputedStyle(this.body, null).getPropertyValue('padding-top'));
            finalPaddingBottom = parseFloat(getComputedStyle(this.body, null).getPropertyValue('padding-bottom'));
        }
        return {
            finalHeight: finalHeight,
            finalPaddingTop: finalPaddingTop,
            finalPaddingBottom: finalPaddingBottom,
        };
    }

    animateCollapse(time) {
        var startTime = this.getStartTime(time);
        var progress = this.getProgress(time);
        var initialStyles = this.getInitialCollapseStyle();
        var {initialHeight, initialPaddingTop, initialPaddingBottom} = initialStyles;
        var {newHeight, newPaddingTop, newPaddingBottom} = this.getProgressCollapseStyles(progress, initialStyles);

        if (progress < 1) {
            this.setState({
                open: false,
                animationInProgress: true,
                animation: {
                    height: newHeight,
                    paddingTop: newPaddingTop,
                    paddingBottom: newPaddingBottom
                }
            })

            this.animation = {
                height: {
                    end: 0,
                    start: initialHeight
                },
                paddingTop: {
                    end: 0,
                    start: initialPaddingTop
                },
                paddingBottom: {
                    end: 0,
                    start: initialPaddingBottom
                },
                startTime: startTime,
                initialFrame: false,
            }

            this.currentAnimation = requestAnimationFrame(this.animateCollapse)
        } else {
            this.setState(this.getDefaultComponentState({open:false}))
            this.context.emitter.emit('tabCloseAnimationEnd', this.group, this.props.name)
        }
    }

    getProgressCollapseStyles(progress, initialStyles) {
        var {initialHeight, initialPaddingTop, initialPaddingBottom} = initialStyles;
        var newHeight = this.getValueByProgress(progress, initialHeight, 0);
        var newPaddingTop = this.getValueByProgress(progress, initialPaddingTop, 0);
        var newPaddingBottom = this.getValueByProgress(progress, initialPaddingBottom, 0);
        return {newHeight: newHeight, newPaddingTop: newPaddingTop, newPaddingBottom: newPaddingBottom};
    }

    getInitialCollapseStyle() {
        var height = this.body.getBoundingClientRect().height;
        var initialFrame = this.animation.initialFrame
        var initialHeight = initialFrame ? height : this.animation.height.start;
        var initialPaddingTop = initialFrame ? parseFloat(getComputedStyle(this.body, null).getPropertyValue('padding-top')) : this.animation.paddingTop.start;
        var initialPaddingBottom = initialFrame ? parseFloat(getComputedStyle(this.body, null).getPropertyValue('padding-bottom')) : this.animation.paddingBottom.start;
        return {
            initialHeight: initialHeight,
            initialPaddingTop: initialPaddingTop,
            initialPaddingBottom: initialPaddingBottom
        };
    }

    getValueByProgress(progress, initialHeight, finalHeight) {
        if (initialHeight < finalHeight) {
            return finalHeight * progress
        } else {
            return initialHeight * (1 - progress)
        }
    }

    getProgress(time) {
        var startTime = this.getStartTime(time);
        return Math.min(1, (time - startTime) / this.props.duration);
    }

    getStartTime(time) {
        var initialFrame = this.animation.initialFrame;
        return initialFrame ? time : this.animation.startTime;
    }
}

AccordionTab.contextTypes = {
    emitter: PropTypes.object.isRequired
};

AccordionTab.defaultProps = {
    duration: 400
}

module.exports = AccordionTab;


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/AccordionTab.jsx